import React from 'react';
import { Link } from 'react-router-dom';

function formatDateline(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d
    .toLocaleDateString(undefined, { month: 'short', day: '2-digit', year: 'numeric' })
    .toUpperCase();
}

export default function ArticleCard({ article }) {
  const {
    url,
    documentId,
    publishedDate,
    category,
    title,
    summary,
    tags,
    imageUrl,
    journalist: j,
    publication: pub,
  } = article;

  return (
    <article className="article-card">
      {imageUrl && (
        <div className="article-card__media">
          <img src={imageUrl} alt="" className="article-card__image" />
        </div>
      )}

      <div className="article-card__body">
        <div className="article-card__dateline">
          <span className="article-card__category">{category}</span>
          <span className="article-card__date">{formatDateline(publishedDate)}</span>
        </div>

        {title && (
          <h3 className="article-card__title">
            <Link to={`/articles/${documentId}`} className="article-card__title-link">
              {title}
            </Link>
          </h3>
        )}
        <p className="article-card__summary">{summary}</p>

        {tags?.length > 0 && (
          <div className="article-card__tags">
            {tags.map((tag, i) => (
              <span key={tag.id ?? i} className="article-card__tag">
                #{tag.value}
              </span>
            ))}
          </div>
        )}

        <div className="article-card__footer">
          <div className="article-card__footer-left">
            {j ? (
              <Link to={`/journalists/${j.documentId}`} className="article-card__byline">
                By {j.firstName} {j.lastName}
              </Link>
            ) : (
              <span className="article-card__byline article-card__byline--muted">
                Unknown journalist
              </span>
            )}
            {pub && (
              <a
                href={pub.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="article-card__publication"
              >
                {pub.name}
              </a>
            )}
          </div>
          <a href={url} target="_blank" rel="noopener noreferrer" className="article-card__link">
            Source ↗
          </a>
        </div>
      </div>
    </article>
  );
}
